import React, { useState } from 'react';
import Sectiontitle from '../../molecules/Sectiontitle';
import Container from '../../atoms/Container';

import image1 from '../../../assets/pics/char/image1.jpg';
import image2 from '../../../assets/pics/char/image2.jpg';
import image3 from '../../../assets/pics/char/image3.jpg';
import Img from '../../molecules/Img';

import { PiCaretLeftBold } from "react-icons/pi";
import { PiCaretRightBold } from "react-icons/pi";
import Button from '../../atoms/Button/Button';
import { colors } from '../../../assets/colors/colors';
import { useTranslation } from 'react-i18next';

export default function Charinpic({data}) {
    // console.log("charinpoc ***********************",data);
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0)
    // console.log("charinpoc ***********************",data[currentIndex]);

    // const images = [image1, image2, image3]; 


    const goToNext = () => setCurrentIndex((currentIndex + 1) % data.length);
    const goToPrevious = () => setCurrentIndex((currentIndex - 1 + data.length) % data.length);

    const getClassName = (index) => {
        // Determine the position of each image (left, center, or right)
        if (index === currentIndex) return "z-20 scale-110 opacity-100";
        if (index === (currentIndex + 1) % data.length) return "translate-x-80 scale-50 z-10 opacity-80";
        if (index === (currentIndex - 1 + data.length) % data.length)
            return "-translate-x-80 scale-50 z-10 opacity-80";
        return "hidden opacity-0"; // Hide non-visible images
    };

    return (
        // <div className='h-[480px] bg-ed-400'>
        <div className='h-fit bg-ed-400'>
            <Sectiontitle title={t("char.gallery.title")} />
            { data?.length >0 ?
            <Container 
                bgColor 
                // className={"h-5/6 mx-6 relative flex items-center justify-center overflow-hidden"}
                className={"h-[480px] mx-6 relative flex items-center justify-center overflow-hidden"}
            >
                <div className="relative flex items-center justify-center w-full h-full m-2 md:m-4 lg:m-24 bg-ed-200">
    
                    <div  >
                            <Button arrow_left onClick={goToNext}>{<PiCaretLeftBold style={{color: colors[1]}}/>}</Button>
                    </div>
                    {/* <div> */}
                    <div className="flex justify-center items-center w-full relative">
                        {/* {images.map((image, index) => ( */}
                        {data?.map((image, index) => (
                            <img
                                key={index}
                                className={`transition-all duration-500 ease-in-out absolute ${getClassName(
                                    index
                                )}  w-[200px] h-[200px] md:w-[250px] md:h-[250px] lg:w-[300px] lg:h-[300px] object-cover`}
                                style={{
                                    // backgroundImage: `url(${encodeURI(image.imageFile)})`,
                                    // backgroundSize: "cover",
                                    // backgroundPosition: "center",
                                    // width: "300px",
                                    // height: "300px",
                                }}
                                src={encodeURI(image.imageFile)}
                                alt={image.imageFile}
                            />
                        ))}
                        </div>
                    {/* </div> */}
                    <div >

                            <Button arrow_right onClick={goToPrevious}>{<PiCaretRightBold style={{color: colors[1]}}/>}</Button>
                    </div>
                </div>
            </Container>
            :
                <div className="text-amber font-cairo-semibold text-xl md:text-3xl">{t("char.gallery.empty")}</div>

            }
        </div>
    );
}
